module.exports = __webpack_public_path__ + "img/image-facebook.dfc0b9ca.png";